module.exports = __webpack_public_path__ + "img/About_Two.fba97e2f.jpg";